// Action Types
export const FETCH_SPOT_CONTACTS_BC_REQUEST = "FETCH_SPOT_CONTACTS_BC_REQUEST";
export const FETCH_SPOT_CONTACTS_BC_SUCCESS = "FETCH_SPOT_CONTACTS_BC_SUCCESS";
export const FETCH_SPOT_CONTACTS_BC_FAILURE = "FETCH_SPOT_CONTACTS_BC_FAILURE";

// Action Creators
export const FetchSpotContactsBCRequest = ({contactId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SPOT_CONTACTS_BC_REQUEST,
      payload: { contactId },
    });
  };
};
export const FetchSpotContactsBCSuccess = (data) => ({
  type: FETCH_SPOT_CONTACTS_BC_SUCCESS,
  payload: data,
});
export const FetchSpotContactsBCFailure = (error) => ({
  type: FETCH_SPOT_CONTACTS_BC_FAILURE,
  payload: error,
});

